// extracted by mini-css-extract-plugin
export default {"root":"DashboardPrivacyPolicy_root__YgCsJ","container":"DashboardPrivacyPolicy_container__KrlKa","padding":"DashboardPrivacyPolicy_padding__jHmOV"};